import { Gallery } from "./gallery";
import { GallerySearchCustom } from "./gallerySearchCustom";


export class GalleryInits {
    constructor() {
        this.initMap();
    }

    initMap() {
        new Gallery();
        new GallerySearchCustom();
    }
}
